import type { Unit } from '@ops/contracts'

import { cx } from '../lib/cx'
import { formatMetricValue } from '../lib/format'

/**
 * La cifra grande de un KPI. Una sola clase para todo el panel.
 *
 * Estaba copiada literal en seis archivos y en dos variantes: tres con
 * `leading-none` y tres sin él. Las dos convivían en la misma fila de /clientes,
 * así que la línea base de los números no coincidía entre tarjetas vecinas —
 * 30px de alto en una y 34px en la de al lado. La altura de línea la declara el
 * token `text-kpi` (`30px/34px` en el preset de Tailwind) y no cada call site:
 * el aire de abajo es parte de la escala tipográfica, no una decisión de tarjeta.
 *
 * Los seis call sites ya están adoptados: los que muestran un `MetricValue`
 * montan el componente, y los tres que arman la cifra a mano (`N de M`,
 * `instalados / contratados`, un valor ya formateado) usan `CLASE_KPI_VALOR`.
 * Que no vuelva a haber un séptimo con el literal lo cuida
 * `__tests__/KpiValor.test.tsx`, que escanea el fuente.
 */
export const CLASE_KPI_VALOR = 'tabular text-kpi font-semibold text-text'

export interface KpiValorProps {
  /** `null` no se renderiza acá: una cifra ausente es `EmptyMetricState`. */
  valor: number
  unidad: Unit
  /** El elemento a emitir. `span` por defecto, para meterlo en una línea. */
  as?: 'span' | 'p'
  testId?: string
  className?: string
}

export function KpiValor({
  valor,
  unidad,
  as: Tag = 'span',
  testId = 'kpi-valor',
  className,
}: KpiValorProps) {
  return (
    <Tag data-testid={testId} className={cx(CLASE_KPI_VALOR, className)}>
      {formatMetricValue(valor, unidad)}
    </Tag>
  )
}
